import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconVisibility = ({ color = 'var(--color-primary-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 0.231445C11.057 0.231445 13.8292 1.90394 15.8748 4.62052C16.0417 4.84309 16.0417 5.15402 15.8748 5.37658C13.8292 8.09644 11.057 9.76893 8 9.76893C4.94303 9.76893 2.17081 8.09644 0.125193 5.37985C-0.041729 5.15729 -0.041729 4.84636 0.125193 4.6238C2.17081 1.90394 4.94303 0.231445 8 0.231445ZM7.78071 8.35827C9.80996 8.48592 11.4857 6.81342 11.3581 4.7809C11.2533 3.10513 9.89506 1.74684 8.21929 1.6421C6.19004 1.51446 4.51427 3.18695 4.64192 5.21948C4.74992 6.89198 6.10821 8.25027 7.78071 8.35827ZM7.88217 6.80688C8.97535 6.87561 9.8787 5.97554 9.80669 4.88236C9.75105 3.97902 9.0179 3.24914 8.11455 3.19023C7.02138 3.12149 6.11803 4.02157 6.19004 5.11474C6.24895 6.02136 6.9821 6.75124 7.88217 6.80688Z"
                fill={color}
                />
        </svg>
    </div>
);

export default IconVisibility;
